import Backbone from "backbone";
import TeamView from "./team";

export default class HomeView extends Backbone.View {

    initialize(options) {
        this.teamView = new TeamView({
            el: this.$el.find('.team')
        });
    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/home.js